import { render, staticRenderFns } from "./ModalAddProductOrdine.vue?vue&type=template&id=4be7d5dd&"
import script from "./ModalAddProductOrdine.vue?vue&type=script&lang=js&"
export * from "./ModalAddProductOrdine.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddProductOrdine.vue?vue&type=style&index=0&id=4be7d5dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports